import { useMatches } from 'react-router-dom';

export default function useCurrentRoute(routeId: string) {
    const matches = useMatches();
    // == 末尾的路由为当前页
    const curr = matches[matches.length - 1];

    return curr ? curr.id === routeId : false;
}
